import * as R from 'ramda';

import { ALL_VERSIONS_URL } from './constants';

export * from './formikHelpers';
export { default as history } from './history';
export * from './constants';
export * from './hooks';
/** A promise that will resolve in the specified number of seconds */
export const sleep = (seconds) =>
  new Promise((resolve) => {
    setTimeout(resolve, seconds * 1000);
  });

/**
 * Takes an array of nested routes and generates nested links for the side nav menu
 *
 * @param {Array} data - array of routes exported from each index file in `pages`
 */
export const generateLinks = (data = []) =>
  data
    .filter((route) => !route.hidden)
    .map((route) => ({
      key: route.path,
      title: route.title || route.linkName,
      icon: route.icon,
      link: route.path.includes(':')
        ? route.path.slice(0, route.path.indexOf(':') - 1)
        : route.path,
      options: {
        exact: false,
      },
      children: generateLinks(route.subRoutes),
    }));

/**
 * Takes an array of nested values and a key for the nested property adn returns a flatten array
 *
 * @param {Array} data - array of objects with one nested property
 * @param {String} nestedKey - the name of the property that has nested values
 */
export const flattenRoutes = (data, nestedKey) =>
  (data ?? []).reduce(
    (pr, current) =>
      current[nestedKey] && current[nestedKey].length
        ? [...pr, current, ...flattenRoutes(current[nestedKey], nestedKey)]
        : [...pr, current],
    [],
  );

/**
 * The function takes a parameter object and returns uri encoded string
 *
 * @param {Object} dict - Object with key:value pairs
 */
export const urlEncode = (dict) =>
  Object.entries(dict)
    .map(([k, v]) => `${encodeURIComponent(k)}=${encodeURIComponent(v)}`)
    .join('&');

/**
 * Takes a dictionary and trims all properties with undefined values
 *
 * @param {Object} params - object with key value pairs
 */
export const removeUndefinedKeys = (params) => {
  if (!params) {
    return {};
  }
  const trimmedObject = {};
  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined) {
      trimmedObject[key] = value;
    }
  });
  return trimmedObject;
};

/**
 * Transforms a boolean or empty value into integer
 * @param {number|string|boolean} value
 * @returns {0|1}
 */
export const valueToInteger = (value) =>
  value === '0' || !value || value === 0 || value === '' ? 0 : 1;

/**
 * Returns the current OS
 * @returns {string}
 */
export const getCurrentOS = () => {
  const { appVersion, userAgent } = navigator;
  if (appVersion.indexOf('Linux') > -1) return 'Linux';
  if (appVersion.indexOf('Mac') > -1) return 'Mac';
  if (appVersion.indexOf('Win') > -1) return 'Win';
  if (userAgent.toLocaleLowerCase().indexOf('phone') > -1) return 'mobile';
  return '';
};

/**
 * Returns the current OS bit system
 * @returns {string|null}
 */
export const getCurrentOSBitSystem = () => {
  const { appVersion } = window.navigator;
  if (appVersion.match(/(x86\b)/g)?.length) return 'x32';
  if (appVersion.match(/(x86_64|x64)\b/g)?.length) return 'x64';
  console.warn('OS bit system is not x32, nor x64');
  return null;
};

export const navigateToLogin = () => {
  const url = new URL('https://login.erply.com/');
  const thisURL = new URL(window.location.href);
  thisURL.searchParams.delete('clientCode');
  thisURL.searchParams.set('auth', 'cookie');
  url.searchParams.set('isLoginAgain', true);
  url.searchParams.set(
    'target',
    `${thisURL.toString()}&clientCode={CLIENTCODE}`,
  );
  window.location.href = url;
};

const versionsFromTxtToArray = R.pipe(
  R.replace(/(\s|\n)*/g, ''),
  R.split(','),
  R.filter((a) => R.not(R.isEmpty(a))),
);
/**
 * Fetches all available versions for 3 main POS environments,
 */
export const fetchPOSAvailableVersionsAndSetToLS = () => {
  const environments = ['pos-dev', 'pos-sb', 'epos'];
  environments.map((environment) =>
    window
      .fetch(`${ALL_VERSIONS_URL}/${environment}/all.txt`)
      .then((r) => r.text())
      .then(versionsFromTxtToArray)
      .then((res) =>
        localStorage.setItem(`versions-${environment}`, JSON.stringify(res)),
      )
      .catch((err) => {
        // eslint-disable-next-line no-console
        console.error('Failed to load available POS versions', err);
        localStorage.setItem(`versions-${environment}`, '[]');
      }),
  );
};
